import { useEffect } from "react";
import { useLocation, Redirect } from "wouter";
import { useAuth } from "@/contexts/AuthContext";
import { Dashboard } from "@/features/dashboard";
import { DashboardSkeleton } from "@/features/dashboard/components/DashboardSkeleton";

/**
 * Wrapper component that redirects staff users to /staff-dashboard instead of showing the dashboard.
 * Only owners and admins see the dashboard.
 */
export default function DashboardWrapper() {
  const [, navigate] = useLocation();
  const { user, isLoading } = useAuth();

  // Show skeleton while checking auth - this prevents any flash
  if (isLoading) {
    return <DashboardSkeleton />;
  }

  // If no user (logged out), redirect to login immediately
  if (!user) {
    return <Redirect to="/login" />;
  }

  // If user is super admin, redirect to super admin dashboard
  if (user.role === "super_admin") {
    return <Redirect to="/super-admin/dashboard" />;
  }

  // If user is staff, redirect to staff dashboard immediately (no render)
  if (user.role === "staff") {
    return <Redirect to="/staff-dashboard" />;
  }

  // Render dashboard for owners and admins only
  return <Dashboard />;
}

